module.exports = __webpack_public_path__ + "static/img/2.4fa3acb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/2.jpg
// module id = s7PV
// module chunks = 0